import { useEffect, useState, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { makeTextFieldAutoFocus, makeTextFieldClear, TextField } from 'shared/ui/TextField'
import { DropdownContent } from 'shared/ui'
import { IntegrationKey } from 'entities/Integrations/api/types'
import { type IContactAll } from 'entities/Contacts'
import { ContactsSearch, ContactsSearchVariantEnum } from 'widgets/ContactsSearch'
import { type SearchDropdownContactsStore } from 'widgets/SearchDropdown/store/searchDropdownContactsStore'
import styles from './styles.module.scss'

type IContactsDropdownContentProps = {
  store: SearchDropdownContactsStore
  onChange?: (item: IContactAll) => void
  width?: number
}

export const ContactsDropdownContent: FC<IContactsDropdownContentProps> = observer(
  ({ store, width, onChange }) => {
    const [selectedTab, setSelectedTab] = useState(false)

    const handleAddItem = (item: IContactAll) => {
      store.selectTypeItem(item)
      onChange?.(item)
    }

    const handleSearch = (value: string) => {
      store.handleSearch(value, false)
    }

    const handleReset = () => {
      return store.resetType()
    }

    useEffect(() => {
      if (!store.hasSelectedItems) setSelectedTab(false)
    }, [store.hasSelectedItems])

    return (
      <DropdownContent noPadding className={styles.wrap} width={width}>
        <TextField
          className={classnames(styles.search, {
            [styles.closed]: !selectedTab,
          })}
          variant='integrated'
          InputProps={{
            placeholder: 'Search contact',
          }}
          onChange={handleSearch}
          value={store.search}
          rightActions={[makeTextFieldClear()]}
          mainActions={[makeTextFieldAutoFocus({ withFocus: !store.search })]}
        />
        <ContactsSearch
          search={store.search}
          onChange={(contact) => {
            handleAddItem(contact)
          }}
          onClearSelected={handleReset}
          variant={
            store.options?.selectedMode
              ? ContactsSearchVariantEnum.checkbox
              : ContactsSearchVariantEnum.default
          }
          selectedMap={store.selectedItemsMap}
          focusedSearch
          hiddenIntegrationsTabs={[IntegrationKey.asana]}
        />
      </DropdownContent>
    )
  }
)
